import {RoleSelector} from "./RoleSelector";

interface UserRoleSectionProps {
    member?: {
        id: number;
        name: string;
        email: string;
        role: string;
    };
    currentRole?: string;
    pendingRole?: string | null;
    onRoleChange?: (role: string) => void;
    isUpdatingRole?: boolean;
    isUniversity?: boolean;
}

export function UserRoleSection({
                                    member,
                                    currentRole,
                                    pendingRole,
                                    onRoleChange,
                                    isUpdatingRole = false,
                                    isUniversity = false
                                }: UserRoleSectionProps) {
    // Map API role values to frontend values
    const mappedCurrentRole = currentRole === 'USER' ? 'user' :
        currentRole === 'ADMIN' ? 'admin' :
            currentRole === 'STUDENT' ? 'student' :
                currentRole?.toLowerCase() || '';

    // Use pending role if available, otherwise use current role
    const displayRole = pendingRole || mappedCurrentRole;

    return (
        <RoleSelector
            role={displayRole}
            onRoleChange={onRoleChange || (() => {
            })}
            disabled={isUpdatingRole}
            isUniversity={isUniversity}
        />
    );
}